/* eslint-disable react/prop-types */
import { useUserRole } from '../../../hooks';

const RoleChecker = ({ allowedRoles = [], children }) => {
  const role = useUserRole();
  return allowedRoles.includes(role) ? children : null;
};

export default RoleChecker;
